import apiClient from '@/services/axios'

export async function del(eventId) {
  var response = await apiClient.delete('/ActivationPlanEvents/' + eventId)
  if (response) {
    return response.data
  }

  throw new Error('Unable to delete event.')
}